export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.685.903a1.002 1.002 0 011.743.256l.039.14c.405 1.98 1.508 4.23 2.64 6.73 1.095 2.416 2.207 5.055 2.372 7.568.12 1.845-.263 3.85-1.626 5.401-1.378 1.569-3.603 2.501-6.795 2.501-2.91 0-5.082-.773-6.53-2.16-1.45-1.391-2.035-3.268-2.028-5.192.01-2.806 1.247-5.551 3.13-8.8a1.001 1.001 0 011.695-.059l.069.12c.562 1.144 1.014 1.952 1.379 2.494.116.173.221.31.31.419a6.45 6.45 0 00.171-.463c.158-.484.315-1.085.501-1.796.183-.699.39-1.486.64-2.295.499-1.61 1.19-3.386 2.29-4.864z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};